import Plyr from 'plyr';
import Scrollbar from 'smooth-scrollbar';
import isTouch from '../helpers/isTouch';
import Swiper from 'swiper/bundle';
import { isDesktop, isTablet, isMobile } from './exportFunc';
export default () =>{
    const openVideoPopupButtons = document.querySelectorAll('[data-popup-video]');
    const defaultPopups = document.querySelectorAll('[data-popup]');
    const cursor = document.querySelector('.cursor');
    const heroPopups = document.querySelectorAll('[hero-video-wrapper]');

    // #region VIDEO POPUP
        openVideoPopupButtons.forEach(button =>{
            const popupName = button.dataset.popupVideo;
            const popup = document.querySelector(`[${popupName}]`);
            if(!popup) {
                return
            }
            const popupVideo = popup.querySelector('[data-inner-video]');
            const section = button.closest('section');
            const overlay = popup.querySelector('.popup__overlay');
            const touchClose = popup.querySelector('[touch-close-popup]');
            const bgVBideo = section.querySelector('[data-home-inner]');

            const myStorage = window.localStorage;
            myStorage.removeItem('plyr')
            if (bgVBideo){
                const pl = new Plyr(bgVBideo, {
                    hideControls:true,
                    controls: false,
                    muted: true,
                    loop: {
                        active: true
                    },
                    vimeo: {
                        loop: true
                    }
                })         
            }


            const player = new Plyr(popupVideo, {
                hideControls: false,
                controls: ['progress', 'mute', 'current-time', 'duration'],
                muted: false,
                invertTime: false,
                displayDuration: true,
                loop: {
                    active: true
                },
                vimeo: {
                    loop: true
                }
               
            });
            let muteButton;
            let controls;
            player.on('ready', (e)=>{
                muteButton =  player.elements.buttons.mute;
                muteButton.innerHTML = 'SOUND OFF';
                controls = popup.querySelector('.plyr__controls');
                const videoTag = popup.querySelector('video');

                if (videoTag) {
                    let playerDuration = popup.querySelector('.plyr__controls__item.plyr__time--duration.plyr__time');
                    function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}
                    let duration = fmtMSS(player.duration)
                    let formattedDuration = duration.split('.');
                    playerDuration.innerHTML = formattedDuration[0]; 
                }
                if (!isTouch()){
                    controls.addEventListener('mouseenter', () => {
                        cursor.classList.remove('cursor-closed');
                    })
                    controls.addEventListener('mouseleave', () =>  cursor.classList.add('cursor-closed'));
                }
                popupVideo.addEventListener('webkitendfullscreen', function (e) { 
                    player.stop();
                    section.classList.remove('fixed');
                    popupClose(popup);
                });
            })

            player.on('volumechange', ()=>{
                        
                if(player.muted == false){
                    muteButton.innerHTML = 'SOUND OFF'
                } else {
                    muteButton.innerHTML = 'SOUND ON'
                }
            
            })
        
            
            if (isDesktop()){
                overlay.addEventListener('click', (e)=>{
                    if (e.target.closest('.plyr__controls')) {return}
                    player.stop();
                    section.classList.remove('fixed');
                    popupClose(popup);
                    cursorHandle(e);
                })
    
            } else {
                touchClose.addEventListener('click', () =>{
                    player.stop();
                    section.classList.remove('fixed');
                    popupClose(popup);
                })
            }
            
            if (isDesktop()){
                button.addEventListener('click', ()=>{
                    openVideoPopup();
                })
            } else {
                const openVideo = section.querySelector('[open-ppp]');
                if (!openVideo)  {return}
                openVideo.addEventListener('click', ()=>{
                    openVideoPopup()
                })
            }

            function openVideoPopup(){
                popupOpen(popup);
                stopPageScroll();
                section.classList.add('fixed');
                
                setTimeout(() => {
                    player.play();
                    
                }, 10);
                
            }

            function cursorHandle(e){
                if (e.target.closest('[data-cursor]')){
                    const parent = e.target.closest('[data-cursor]');
                    if (!isTouch()){
                        cursor.classList.add('hovered');
                        cursor.innerHTML = parent.dataset.cursor;
                    }
                }
            }
                    
        })
    //#endregion

    //#region DEFAULT POPUP
        defaultPopups.forEach(button =>{
           
            const popupName = button.dataset.popup;
            const popup = document.querySelector(`[${popupName}]`);

            if (!popup) return;

            const close = popup.querySelectorAll('[close-popup]');
            const section = button.closest('section');
            const touchClose = popup.querySelector('[touch-close-popup]');
            const overlay = popup.querySelector('.popup__overlay');

            button.addEventListener('click', (e)=>{
                e.stopPropagation();
                let scr;

                popupOpen(popup);
                button.classList.contains('floor-plan-btn')?scr = 0:false
                stopPageScroll(scr);
                section.classList.add('fixed');
                section.style.height = overlay.scrollHeight + 'px';
                if (!isTouch()){
                    cursor.classList.add(button.dataset.cursorColor);
                }
            })
            
            if (isDesktop()) {
                overlay.addEventListener('click', (e)=>{
                    if (e.target.closest('a, .btn, button, canvas')){ return }
                    section.classList.remove('fixed');
                    resumePageScroll();
                    popupClose(popup);
                    section.style.height = '100%';
                    if (!isTouch()){
                        cursor.classList.remove(button.dataset.cursorColor);
                    }
                })
            } else {
                touchClose.addEventListener('click', () =>{
                    section.classList.remove('fixed');
                    resumePageScroll();
                    popupClose(popup);
                    section.style.height = '100%';
                })
            }

            if (!isTouch()){
                popup.querySelectorAll('a, button').forEach(link =>{
                    link.addEventListener('mouseenter', () => {
                        cursor.classList.remove('cursor-closed');
                    })
                    link.addEventListener('mouseleave', () =>  cursor.classList.add('cursor-closed'));
                })
            } 
        })
    //#endregion

    //#region HERO VIDEO AND POPUPS
        heroPopups.forEach(hero =>{
            const myStorage = window.localStorage;
            myStorage.removeItem('plyr')
            //#region background player
                const video = hero.querySelector('[hero-video]');
                const openVideo = hero.closest('section').querySelector('[open-ppp]')
                
                const backgroundPlayer = new Plyr(video, {
                    hideControls: false,
                    autoplay: true,
                    autopause: false,
                    controls: ['progress'],
                    muted: true,
                    storage: {
                        enabled: false
                    },
                    loop: {
                        active: true
                    },
                    vimeo: {
                        loop: true
                    }
                });
            //#endregion
            
            //#region Popup player
                const popupName = video.dataset.open;
                const popup = document.querySelector(`[${popupName}]`);
                const popupVideo = popup.querySelector('[data-inner-video]');
                const touchClose = popup.querySelector('[touch-close-popup]');
                
                const player = new Plyr(popupVideo, {
                    hideControls: false,
                    controls: ['progress', 'mute', 'current-time', 'duration'],
                    muted: false,
                    invertTime: false,
                    autoplay: false,
                    displayDuration: true,
                    storage: {
                        enabled: false
                    },
                    loop: {
                        active: true
                    },
                    vimeo: {
                        loop: true
                    }
                    
                });
                let muteButton;
                let controls;
                player.on('ready', (e)=>{
                    muteButton =  player.elements.buttons.mute;
                    muteButton.innerHTML = 'SOUND OFF';
                    controls = popup.querySelector('.plyr__controls');
                    
                    const videoTag = popup.querySelector('video');

                    if (videoTag) {
                        let playerDuration = popup.querySelector('.plyr__controls__item.plyr__time--duration.plyr__time');
                        function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}
                        let duration = fmtMSS(player.duration)
                        let formattedDuration = duration.split('.');
                        playerDuration.innerHTML = formattedDuration[0]; 
                    }
                })
                
                player.on('volumechange', ()=>{
                    
                    if(player.muted == false){
                        muteButton.innerHTML = 'SOUND OFF'
                    } else {
                        muteButton.innerHTML = 'SOUND ON'
                    }
                
                })

                hero.addEventListener('click', () =>{
                    openPopupVideo();
                })
                openVideo.addEventListener('click', () =>{
                    openPopupVideo();
                })

                function openPopupVideo(){
                    setVH();
                    popupOpen(popup);
                    stopPageScroll();
                    player.play()
                    if (!isTouch()){
                        controls.addEventListener('mouseenter', () => {
                            cursor.classList.remove('cursor-closed');
                        })
                        controls.addEventListener('mouseleave', () =>  cursor.classList.add('cursor-closed'));
                    }
                }

                function clossePopupVideo(){
                    popupClose(popup, player);
                    setTimeout(() => {
                        player.stop();
                        backgroundPlayer.play();
                    }, 5);
                    
                }

                if (isDesktop()){
                    player.elements.wrapper.addEventListener('click', (e)=>{
                        resetVH();
                        clossePopupVideo()   
                        if (e.target.closest('[data-cursor]')){
                            const parent = e.target.closest('[data-cursor]');
                            if (!isTouch()){
                                cursor.classList.add('hovered');
                                cursor.innerHTML = parent.dataset.cursor;
                            }
                        }
                    })
                } else {
                    touchClose.addEventListener('click', () =>{
                        clossePopupVideo()
                    })
                }

                popupVideo.addEventListener('webkitendfullscreen', function (e) { 
                    clossePopupVideo()
                });
            //#endregion
        })
    //#endregion

    //#region OPEN AND CLOSE

        function popupClose(popup, player){
            popup.classList.remove('open');
            if (!isTouch()){
                cursor.classList.remove('cursor-closed');
            }
            document.querySelector('.scroll-container').style.zIndex = 1;
            
            resumePageScroll()
            player?player.stop():false;
            
        }
        
        function popupOpen(popup){
            scrollCurrent = scrollStatus;
            popup.classList.add('open');
            if (!isTouch()){
                cursor.classList.add('cursor-closed');
                cursor.classList.remove('hovered');
            }
            document.querySelector('.scroll-container').style.zIndex = 1010;
        }

    //#endregion

    //#region SMOOTH SCROLL POPUP FIXED BUGS

        let scrollStatus, scrollCurrent;
        let scrollbar = Scrollbar.get(document.querySelector('.scroll-container'));
        scrollbar.addListener((status) => {
            scrollStatus = status.offset.y;
        });

        function setVH(){
            document.querySelectorAll('.popup, .popup__overlay').forEach( el => {
                el.style.height="100vh";
                el.style.minHeight="auto";
            })
        }

        function resetVH(){
            document.querySelectorAll('.popup, .popup__overlay').forEach( el => {
                el.style.height="";
                el.style.minHeight="100vh";
            })
        }

        function stopPageScroll(scrollTop = 0){
            scrollbar.contentEl.querySelector('.scroll-inner-content').classList.add('scroll-content--stoped');
            scrollbar.scrollTop = scrollTop;
            scrollbar.update();
        }

        function resumePageScroll(){
            scrollbar.contentEl.querySelector('.scroll-inner-content').classList.remove('scroll-content--stoped');
            scrollbar.update();
            scrollbar.scrollTop = scrollCurrent;
        }

    //#endregion

    //#region gallery popup
        galleryPopup();
        function galleryPopup() {
            let galleryPopupBody = document.querySelector('.gallery-popup'),
                gallery = document.querySelector('.gallery');
            if(!galleryPopupBody || !gallery) {
                return;
            }

            function galleryPopupInit() {
                let popupSlider = galleryPopupBody.querySelector('.gallery-popup__inner');
                const popupGal = new Swiper(popupSlider, {
                    wrapperClass: "gallery-popup__slider",
                    slideClass: "gallery-popup__item",
                    slideActiveClass: "is-active",
                    freemode: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    loop: false,
                    navigation: {
                        nextEl: '.gallery-popup__next',
                        prevEl: '.gallery-popup__prev',
                    },
                    pagination: {
                        el: '.gallery-popup__count',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            return ('0' + current).slice(-2) + ' / ' + ('0' + total).slice(-2);
                        }
                    },
                });
                return popupGal;
            }


            function openGalPopup(index) {
                galleryPopupInit().slideTo(index, 0);
                galleryPopupBody.classList.add('open');
                document.querySelector('header').setAttribute('style', 'z-index:-1;');
            }



            gallery.querySelectorAll('.gallery__image-container').forEach((el, index)=>{
                el.addEventListener('click', ()=>{
                    scrollbar.updatePluginOptions('modal', { open: true });
                    openGalPopup(index);
                });
            });

            galleryPopupBody.querySelector('.gallery-popup__close').addEventListener('click', ()=>{
                scrollbar.updatePluginOptions('modal', { open: false });
                popupClose(galleryPopupBody);
                document.querySelector('header').setAttribute('style', '');
                document.querySelectorAll('.gallery-popup video').forEach(el=>{
                    el.pause();
                })
            });
        }
    //#endregion

    //#region OTHER PLYR VIDEOS
        const defaultVimeos = document.querySelectorAll('[data-vimeo-default]');

        defaultVimeos.forEach(el =>{
            const pl = new Plyr(el, {
                hideControls:true,
                controls: false,
                muted: true,
                autoplay: true,
                autopause: false,
                loop: {
                    active: true
                },
                vimeo: {
                    loop: true
                }
            })    
        })
    //#endregion
}